import type { ActivityModule } from '../../core/activity';
import { mountGuess24 } from './ui';
import levelsData from './levels.json';
import './style.css';

export const guess24: ActivityModule = {
  id: 'guess24',
  title: 'Adivinhe 24',
  description: 'Combine 4 números com +, −, × e ÷ pra chegar a 24.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/guess24/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountGuess24,
};
